
























































































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio } from '@/components/form'
import TableAfpItems from './TableAfpItems.vue'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, decimal, minValue } from 'vuelidate/lib/validators'

// models
import { AfpForm, AfpItemForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'
import { monthOptions, rangeYearsDefault } from '@/constants/dateTime'

// utils
import { loading, alerts } from '@/utils'

// services
import { AfpService } from '@/services/config'

const afpItemInit: AfpItemForm = {
  percentage_flow: 0,
  mixed_percentage: 0,
  contribution: 0,
  insurance_premium: 0,
  flow: 0,
  mixed: 0,
  safe_stop: 0,
  year: null,
  month: null
}

const initItem: AfpForm = {
  name: '',
  observations: '',
  is_active: true,
  items: []
}

@Component({
    name: 'FormCreateEditAfp',
    components: {
        Input,
        Radio,
        TableAfpItems
    },
    mixins: [validationMixin]
})
export default class FormCreateEditAfp extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) afp!: AfpForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    monthOptions = monthOptions
    rangeYearsDefault = rangeYearsDefault
    form: AfpForm = {
        name: '',
        observations: '',
        is_active: true,
        items: []
    }

    created () {
        if (this.idEdit) {
            this.form = {
                ...this.afp
            }
        }
    }

    @Validations()
    validations () {
        return {
            form: {
                name: { required, minLength: minLength(2) },
                items: {
                    required,
                    $each: {
                        percentage_flow: { required, decimal, minValue: minValue(0) },
                        mixed_percentage: { required, decimal, minValue: minValue(0) },
                        contribution: { required, decimal, minValue: minValue(0) },
                        insurance_premium: { required, decimal, minValue: minValue(0) },
                        safe_stop: { required, decimal, minValue: minValue(0) },
                        year: { required },
                        month: { required }
                    }
                },
                is_active: { required }
            }
        }
    }

    addItem () {
        this.form.items.push({
            ...afpItemInit
        })
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await AfpService.update(this.idEdit, this.form)
                } else {
                    await AfpService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = initItem
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
